// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fonts_size_com {
  font-size: 11px !important;
}

.deploymentForm {
  width: 60%;
}

.custom-autocomplete-input {
  /* Add styles to make the input field resemble an autocomplete component */
  border-radius: 5px;
  border: 1px solid #f2f4f7;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.21); /* Add box shadow */
}

.label_content {
  float: left;
  position: relative;
  padding-left: 2%;
  padding-bottom: 1%;
}

.controls_feild {
  width: 70%;
  float: left;
  margin-left: 4%;
  height: 35px;
}

.controls_feild_lookvalue {
  width: 69%;
  float: left;
  margin-left: 4%;
  height: 35px;
}

.copy_iconss {
  background-repeat: no-repeat;
  display: inline-block;
  fill: currentColor;
  height: 24px;
  width: 24px;
  font-size: 18px;
  position: relative;
  top: 8%;
  left: 2%;
  cursor: pointer;
}

.custom-scrollbar {
  height: 100vh; /* Set height to fill the viewport */
  overflow-y: auto; /* Allow vertical scrollbar if content exceeds viewport height */
  overflow-x: hidden; /* Hide horizontal scrollbar */
  padding-right: 17px; /* Add space for scrollbar to avoid content shifting */
}

/* Custom scrollbar styling */
.custom-scrollbar::-webkit-scrollbar {
  width: 10px; /* Set width of scrollbar */
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: #f1f1f1; /* Background color of scrollbar track */
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #888; /* Color of scrollbar thumb */
  border-radius: 5px; /* Border radius of scrollbar thumb */
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #555; /* Color of scrollbar thumb on hover */
}

.formStyle {
  background-color: #f5f2f2;
}

.customResponse {
  overflow: auto;
  width: 100%;
  overflow-x: hidden;
}

.responseDiv {
  align-items: center;
  white-space: nowrap !important;
  width: 85% !important;
  text-overflow: ellipsis !important;
  overflow: hidden !important;
}

.lookupDiv {
  display: inline-block;
  overflow-y: auto;
  max-height: 13vh;
}

.custom-paginator {
  height: 144%;
  display: flex;
  align-items: center;
}

.searchLable {
  align-content: center;
  text-align: right;
  padding-right: 0px;
}

.paginator-container {
  position: fixed;
  bottom: 0;
  width: 95%;
  display: flex;
  justify-content: flex-end;
}

.button-with-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.handlercard {
  border-radius: 0% !important;
  font-size: medium;
  color: white;
  margin-bottom: 8px;
}

.custommap-popup {
  width: 168vh;
  background-color: #fff;
  right: -303px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 34px;
  height: 26vb;
}`, "",{"version":3,"sources":["webpack://./src/app/integrationmapping/integrationmapping.component.scss"],"names":[],"mappings":"AAAA;EACI,0BAAA;AACJ;;AAEA;EACI,UAAA;AACJ;;AAEA;EACI,0EAAA;EACA,kBAAA;EACA,yBAAA;EACA,yCAAA,EAAA,mBAAA;AACJ;;AAEA;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,UAAA;EACE,WAAA;EACA,eAAA;EACA,YAAA;AACN;;AAEE;EACE,UAAA;EACE,WAAA;EACA,eAAA;EACA,YAAA;AACN;;AAEE;EACE,4BAAA;EACE,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;AACN;;AAEE;EACE,aAAA,EAAA,oCAAA;EACA,gBAAA,EAAA,gEAAA;EACA,kBAAA,EAAA,8BAAA;EACA,mBAAA,EAAA,sDAAA;AACJ;;AAEA,6BAAA;AACA;EACI,WAAA,EAAA,2BAAA;AACJ;;AAEA;EACI,mBAAA,EAAA,wCAAA;AACJ;;AAEA;EACI,gBAAA,EAAA,6BAAA;EACA,kBAAA,EAAA,qCAAA;AACJ;;AAEA;EACI,gBAAA,EAAA,sCAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,cAAA;EACA,WAAA;EACA,kBAAA;AACJ;;AAEA;EAGI,mBAAA;EACA,8BAAA;EACA,qBAAA;EACA,kCAAA;EACA,2BAAA;AADJ;;AAKA;EACI,qBAAA;EACA,gBAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,YAAA;EACA,aAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,qBAAA;EACA,iBAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,eAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,yBAAA;AAFJ;;AAKA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAFJ;;AAKE;EACE,4BAAA;EACA,iBAAA;EAEA,YAAA;EACA,kBAAA;AAHJ;;AAME;EACE,YAAA;EACA,sBAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,SAAA;EACA,YAAA;AAHJ","sourcesContent":[".fonts_size_com{\r\n    font-size:11px !important;\r\n  }\r\n\r\n.deploymentForm{\r\n    width: 60%;\r\n}\r\n\r\n.custom-autocomplete-input {\r\n    /* Add styles to make the input field resemble an autocomplete component */\r\n    border-radius: 5px;\r\n    border: 1px solid #f2f4f7;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.21); /* Add box shadow */\r\n}\r\n\r\n.label_content{\r\n    float: left;\r\n    position: relative;\r\n    padding-left: 2%;\r\n    padding-bottom: 1%;\r\n  }\r\n\r\n.controls_feild{\r\n    width: 70%;\r\n      float: left;\r\n      margin-left: 4%;\r\n      height: 35px;\r\n  }\r\n  \r\n  .controls_feild_lookvalue{\r\n    width: 69%;\r\n      float: left;\r\n      margin-left: 4%;\r\n      height: 35px;\r\n  }\r\n\r\n  .copy_iconss{\r\n    background-repeat: no-repeat;\r\n      display: inline-block;\r\n      fill: currentColor;\r\n      height: 24px;\r\n      width: 24px;\r\n      font-size: 18px;\r\n      position: relative;\r\n      top: 8%;\r\n      left: 2%;\r\n      cursor: pointer;\r\n  }\r\n\r\n  .custom-scrollbar {\r\n    height: 100vh; /* Set height to fill the viewport */\r\n    overflow-y: auto; /* Allow vertical scrollbar if content exceeds viewport height */\r\n    overflow-x: hidden; /* Hide horizontal scrollbar */\r\n    padding-right: 17px; /* Add space for scrollbar to avoid content shifting */\r\n}\r\n\r\n/* Custom scrollbar styling */\r\n.custom-scrollbar::-webkit-scrollbar {\r\n    width: 10px; /* Set width of scrollbar */\r\n}\r\n\r\n.custom-scrollbar::-webkit-scrollbar-track {\r\n    background: #f1f1f1; /* Background color of scrollbar track */\r\n}\r\n\r\n.custom-scrollbar::-webkit-scrollbar-thumb {\r\n    background: #888; /* Color of scrollbar thumb */\r\n    border-radius: 5px; /* Border radius of scrollbar thumb */\r\n}\r\n\r\n.custom-scrollbar::-webkit-scrollbar-thumb:hover {\r\n    background: #555; /* Color of scrollbar thumb on hover */\r\n}\r\n\r\n.formStyle{\r\n    background-color: #f5f2f2;;\r\n}\r\n\r\n.customResponse{\r\n    overflow: auto; \r\n    width: 100%;\r\n    overflow-x: hidden;\r\n}\r\n\r\n.responseDiv{\r\n    // display: flex;\r\n    // justify-content: center;\r\n    align-items: center;\r\n    white-space: nowrap !important;\r\n    width: 85% !important;\r\n    text-overflow: ellipsis !important;\r\n    overflow: hidden !important;\r\n     \r\n}\r\n\r\n.lookupDiv{\r\n    display: inline-block;\r\n    overflow-y: auto;\r\n    max-height: 13vh;\r\n}\r\n\r\n.custom-paginator{\r\n    height: 144%;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.searchLable{\r\n    align-content: center;\r\n    text-align: right;\r\n    padding-right: 0px;\r\n}\r\n\r\n.paginator-container {\r\n    position: fixed;\r\n    bottom: 0;\r\n    width: 95%;\r\n    display: flex;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.button-with-icon {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n  .handlercard {\r\n    border-radius: 0% !important;\r\n    font-size: medium;\r\n    //font-family: 'FontAwesome';\r\n    color: white;\r\n    margin-bottom: 8px;\r\n  }\r\n\r\n  .custommap-popup {\r\n    width: 168vh;\r\n    background-color: #fff;\r\n    right: -303px;\r\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n    position: fixed;\r\n    top: 34px;\r\n    height: 26vb;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
